import React from 'react';

interface InputLabelCompProps {
  label: string;
  isRequired?: boolean;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const InputLabelComp: React.FC<InputLabelCompProps> = ({
  label,
  isRequired,
  value,
  onChange,
  error,
}) => (
  <div className={error ? 'error' : ''}>
    <label>
      {label}
      {isRequired && <span className='required'>*</span>}
    </label>
    <textarea
      className='textarea-input-style'
      placeholder='Please provide details'
      rows={1}
      onChange={(e) => onChange(e.target.value)}
      value={value}
    />
    {error && <div className='error-text-message'>{error}</div>}
  </div>
);

export default InputLabelComp;
